import TooltipIcon from '../../../components/svg/tooltip-icon'
import useMemberships from '../../../hooks/use-memberships'

export default function MembershipInfoInBuyAgreement() {
  const [memberships] = useMemberships([])

  if (memberships?.memberships?.length === 0) return null

  return (
    <div className='root flex'>
      <div>
        <TooltipIcon width={18} height={18} style={{ marginRight: 10 }} />
      </div>
      <div className='description'>
        You are going to purchase a vehicle from a Dealer that gives benefits to members of
        {memberships?.memberships?.map((data) => {
          return <span key={data.programId}>&nbsp;{data.programName},</span>
        })}{' '}
        like you! <br />
        <br />
        You can check with the Dealer for full details of benefits.
      </div>
      <style jsx>{`
        .root {
          padding: 2rem 0;
          span {
            font-weight: bold;
          }
          .description {
            font-size: 1.4rem;
          }
        }
      `}</style>
    </div>
  )
}
